import { BOT_OPS_SECTIONS } from "./botOpsSections";

const BotOpsSectionNav = ({ section, onSectionChange }) => (
    <nav
        aria-label="Seções do Bot Ops"
        className="flex gap-1.5 overflow-x-auto pb-2 mb-5 border-b border-[#b47c06]/30 -mx-1 px-1"
    >
        {BOT_OPS_SECTIONS.map((s) => {
            const active = section === s.id;
            return (
                <button
                    key={s.id}
                    type="button"
                    aria-pressed={active}
                    onClick={() => onSectionChange(s.id)}
                    className={`shrink-0 px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                        active
                            ? "bg-[#d59106] text-black shadow-sm ring-2 ring-[#d59106]/40"
                            : "bg-gray-900/60 text-gray-300 hover:bg-gray-800 hover:text-white border border-transparent"
                    }`}
                >
                    {s.label}
                </button>
            );
        })}
    </nav>
);

export default BotOpsSectionNav;
